/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { webhookControllerHandleCheckoutStripeEvent } from '../fn/webhook/webhook-controller-handle-checkout-stripe-event';
import { WebhookControllerHandleCheckoutStripeEvent$Params } from '../fn/webhook/webhook-controller-handle-checkout-stripe-event';
import { webhookControllerHandleSetupIntentStripeEvent } from '../fn/webhook/webhook-controller-handle-setup-intent-stripe-event';
import { WebhookControllerHandleSetupIntentStripeEvent$Params } from '../fn/webhook/webhook-controller-handle-setup-intent-stripe-event';
import { webhookControllerHandleStripeWebhook } from '../fn/webhook/webhook-controller-handle-stripe-webhook';
import { WebhookControllerHandleStripeWebhook$Params } from '../fn/webhook/webhook-controller-handle-stripe-webhook';

@Injectable({ providedIn: 'root' })
export class WebhookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `webhookControllerHandleStripeWebhook()` */
  static readonly WebhookControllerHandleStripeWebhookPath = '/keus-payments/webhook/stripe';

  /**
   * Handle all Stripe webhook events.
   *
   * Single endpoint for all Stripe webhooks. Configure this URL in Stripe Dashboard: https://your-domain.com/webhook/stripe
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookControllerHandleStripeWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleStripeWebhook$Response(params: WebhookControllerHandleStripeWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return webhookControllerHandleStripeWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle all Stripe webhook events.
   *
   * Single endpoint for all Stripe webhooks. Configure this URL in Stripe Dashboard: https://your-domain.com/webhook/stripe
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhookControllerHandleStripeWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleStripeWebhook(params: WebhookControllerHandleStripeWebhook$Params, context?: HttpContext): Observable<void> {
    return this.webhookControllerHandleStripeWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `webhookControllerHandleCheckoutStripeEvent()` */
  static readonly WebhookControllerHandleCheckoutStripeEventPath = '/keus-payments/webhook/checkout';

  /**
   * [DEPRECATED] Handle Stripe checkout events.
   *
   * Legacy endpoint - use /webhook/stripe instead
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookControllerHandleCheckoutStripeEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleCheckoutStripeEvent$Response(params: WebhookControllerHandleCheckoutStripeEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return webhookControllerHandleCheckoutStripeEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * [DEPRECATED] Handle Stripe checkout events.
   *
   * Legacy endpoint - use /webhook/stripe instead
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhookControllerHandleCheckoutStripeEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleCheckoutStripeEvent(params: WebhookControllerHandleCheckoutStripeEvent$Params, context?: HttpContext): Observable<void> {
    return this.webhookControllerHandleCheckoutStripeEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `webhookControllerHandleSetupIntentStripeEvent()` */
  static readonly WebhookControllerHandleSetupIntentStripeEventPath = '/keus-payments/webhook/setup-intent';

  /**
   * [DEPRECATED] Handle Stripe setup intent events.
   *
   * Legacy endpoint - use /webhook/stripe instead
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookControllerHandleSetupIntentStripeEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleSetupIntentStripeEvent$Response(params: WebhookControllerHandleSetupIntentStripeEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return webhookControllerHandleSetupIntentStripeEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * [DEPRECATED] Handle Stripe setup intent events.
   *
   * Legacy endpoint - use /webhook/stripe instead
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhookControllerHandleSetupIntentStripeEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookControllerHandleSetupIntentStripeEvent(params: WebhookControllerHandleSetupIntentStripeEvent$Params, context?: HttpContext): Observable<void> {
    return this.webhookControllerHandleSetupIntentStripeEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
